import { useEffect, useRef, useState } from 'react';

interface Options {
    /// Respiro entre o fim do bloco e a borda de baixo da janela, mais o que vier depois dele.
    bottomGap?: number;

    /// Piso: abaixo disto o bloco vira uma fresta inútil, e é melhor a página rolar.
    minHeight?: number;
}

/** Altura do bloco até o fim da janela; mudar a chave força nova medição. */
export const useAvailableHeight = (key = '', { bottomGap: bottomGap = 28, minHeight: minHeight = 220 }: Options = {}) => {
    const topRef = useRef<HTMLDivElement | null>(null);
    const targetRef = useRef<HTMLDivElement | null>(null);
    const [height, setHeight] = useState<number | null>(null);
    const [scrollbarHeight, setScrollbarHeight] = useState(0);

    useEffect(() => {
        const measure = () => {
            const target = targetRef.current;
            if (!target) return;

            const horizontalScrollbar = target.offsetHeight - target.clientHeight;

            const available = window.innerHeight
                - target.getBoundingClientRect().top
                - bottomGap
                - horizontalScrollbar;

            setHeight(Math.max(minHeight, available));
            setScrollbarHeight(horizontalScrollbar);
        };

        measure();

        const observer = new ResizeObserver(measure);
        if (topRef.current) observer.observe(topRef.current);
        window.addEventListener('resize', measure);

        return () => {
            observer.disconnect();
            window.removeEventListener('resize', measure);
        };
    }, [key, bottomGap, minHeight]);

    return { topRef, targetRef, height, scrollbarHeight };
};
